import * as React from 'react';

const ClearIcon = ({ className }) => {
    return (<svg width="24" height="24" className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.8438 16.875C16.6562 17.0625 16.3125 17.0625 16.125 16.875L12 12.7188L7.84375 16.875C7.65625 17.0625 7.3125 17.0625 7.125 16.875C6.9375 16.6875 6.9375 16.3438 7.125 16.1562L11.2812 12L7.125 7.875C6.9375 7.6875 6.9375 7.34375 7.125 7.15625C7.3125 6.96875 7.65625 6.96875 7.84375 7.15625L12 11.3125L16.125 7.15625C16.3125 6.96875 16.6562 6.96875 16.8438 7.15625C17.0312 7.34375 17.0312 7.6875 16.8438 7.875L12.6875 12L16.8438 16.1562C17.0312 16.3438 17.0312 16.6875 16.8438 16.875Z"/>
    </svg>
    );
}

export default ClearIcon;